import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../i18n';

// Промо-лендінг платформи (для гостей на корені платформи «/»).
// Самодостатній: власна навігація, скоуповані стилі (.mkt), трилінгва.
// Дизайн: «вишня на кремі» — теплий крем + вишня-oxblood + карамель,
// шоколадні темні акценти (мок-віджет, бренд-банд), серифний дисплей.

const DICT = {
  pl: {
    nav_features: 'Możliwości', nav_how: 'Jak to działa', nav_pricing: 'Cennik', nav_cta: 'Wypróbuj za darmo', nav_login: 'Zaloguj się',
    hero_eyebrow: 'Platforma dla salonów i specjalistów',
    hero_h1: 'Twój salon działa online — <em>rezerwacje 24/7</em>, gdy Ty pracujesz.',
    hero_sub: 'Klienci rezerwują sami, potwierdzają numer kodem SMS, a Ty widzisz wszystko w jednym kalendarzu.',
    hero_cta1: 'Zacznij za darmo', hero_cta2: 'Zobacz, jak to działa',
    hero_n1: '3 miesiące za darmo', hero_n2: 'bez karty', hero_n3: 'rezygnacja w każdej chwili',
    dev_sub: 'Rezerwacja online', dev_time: 'Wybierz godzinę', dev_code: 'Kod z SMS', dev_btn: 'Zarezerwuj', dev_booked: 'Zarezerwowano — do zobaczenia!',
    v1: 'Zapisy online, bez telefonów', v2: 'Potwierdzenie numeru kodem', v3: 'Prowizji od rezerwacji', v4: 'Strona w trzech językach',
    feat_eyebrow: 'Wszystko w jednym miejscu', feat_title: 'Salon prowadzisz Ty. Resztą zajmuje się appointMe.',
    feat_sub: 'Od pierwszej rezerwacji po własną stronę z marką — bez kodu i bez papierologii.',
    f1t: 'Rezerwacja online z kodem', f1d: 'Klient wybiera usługę, mistrza i godzinę, a numer potwierdza kodem SMS — koniec z „no-show”.',
    f2t: 'Własna strona i subdomena', f2d: 'Każdy salon dostaje markową stronę pod adresem twoj-salon.aptme.app — gotową do reklamy.',
    f3t: 'Strona w Twoich barwach', f3d: 'Kolory, czcionka, logo i tło — 16 gotowych motywów albo własna paleta. Zero kodu.',
    f4t: 'Grafik i zespół', f4d: 'Godziny pracy, dni wolne, role (właściciel, administrator, mistrz) — cały salon w jednym panelu.',
    f5t: 'Usługi, ceny i klienci', f5d: 'Cennik, indywidualna cena wizyty i baza klientów — wszystko pod ręką.',
    f6t: 'Panel z kalendarzem', f6d: 'Widok dnia i kalendarz z szybkim dodawaniem wizyt — cały dzień na widoku.',
    how_eyebrow: 'Start w jedno popołudnie', how_title: 'Trzy kroki do pierwszej rezerwacji',
    s1t: 'Załóż salon i usługi', s1d: 'Dodaj zespół, usługi i ceny. Pierwsze 3 miesiące za darmo, bez podawania karty.',
    s2t: 'Ustaw stronę i subdomenę', s2d: 'Wybierz motyw, dopasuj kolory i logo — Twoja strona rezerwacji działa pod własnym adresem.',
    s3t: 'Przyjmuj rezerwacje 24/7', s3d: 'Udostępnij link — klienci rezerwują sami, a Ty widzisz wszystko w kalendarzu.',
    price_eyebrow: 'Prosty cennik', price_title: 'Płacisz tylko za mistrzów. Bez prowizji od wizyt.',
    price_sub: 'Nowe salony mają pierwsze 3 miesiące za darmo. Potem płacisz za każdego mistrza, który przyjmuje rezerwacje. Wygodna płatność kartą online.',
    mo: 'mies.', per_master: 'za mistrza / mies.', plan_title: 'Jedna prosta stawka', trial_tag: '3 miesiące gratis', plan_cta: 'Zacznij za darmo',
    b1: 'Publiczna strona i rezerwacje online', b2: 'Bez limitu mistrzów i usług', b3: 'Potwierdzenia SMS',
    p1: 'Własna subdomena i branding strony', p2: 'Kalendarz, klienci, księgowość', p3: 'Kody promocyjne i przypomnienia', p4: 'Liczy się każdy, kto przyjmuje rezerwacje — administratorzy bez kalendarza za darmo',
    price_note: 'Przykład: solo mistrz — 69 zł/mies., salon z 4 mistrzami — 276 zł/mies. Zrezygnować możesz w każdej chwili — dostęp działa do końca opłaconego okresu.',
    brand_eyebrow: 'Twoja marka, nie nasza', brand_title: 'Każdy salon to osobna marka pod własnym adresem.',
    brand_sub: 'Motyw i logo dopasowane do Ciebie — a link wygląda profesjonalnie w reklamie i w social media.',
    bl1: 'Własna subdomena i motyw', bl2: 'Strona w PL, UA i EN', bl3: 'Gotowy link do reklam i social media',
    cta_title: 'Gotowy przenieść rezerwacje do sieci?', cta_sub: 'Załóż salon w kilka minut albo napisz do nas — pokażemy demo i pomożemy wystartować.',
    cta_btn: 'Załóż salon', cta_btn2: 'Napisz do nas',
    foot_tag: 'Platforma rezerwacji online dla salonów.',
  },
  uk: {
    nav_features: 'Можливості', nav_how: 'Як працює', nav_pricing: 'Ціни', nav_cta: 'Спробувати безкоштовно', nav_login: 'Увійти',
    hero_eyebrow: 'Платформа для салонів і майстрів',
    hero_h1: 'Твій салон живе онлайн — <em>записи 24/7</em>, поки ти працюєш.',
    hero_sub: 'Клієнти бронюють самі, підтверджують номер кодом із SMS, а ти бачиш усе в одному календарі.',
    hero_cta1: 'Почати безкоштовно', hero_cta2: 'Подивитись, як це працює',
    hero_n1: '3 місяці безкоштовно', hero_n2: 'без картки', hero_n3: 'скасування будь-коли',
    dev_sub: 'Онлайн-запис', dev_time: 'Оберіть час', dev_code: 'Код із SMS', dev_btn: 'Записатись', dev_booked: 'Заброньовано — до зустрічі!',
    v1: 'Записи онлайн, без дзвінків', v2: 'Підтвердження номера кодом', v3: 'Комісії з бронювань', v4: 'Сторінка трьома мовами',
    feat_eyebrow: 'Усе в одному місці', feat_title: 'Салоном керуєш ти. Решту бере на себе appointMe.',
    feat_sub: 'Від першого запису до власної сторінки з брендом — без коду й паперів.',
    f1t: 'Онлайн-запис із кодом', f1d: 'Клієнт обирає послугу, майстра й час, а номер підтверджує кодом із SMS — жодних «не прийшов».',
    f2t: 'Власна сторінка й піддомен', f2d: 'Кожен салон отримує брендовану сторінку за адресою твій-салон.aptme.app — готову до реклами.',
    f3t: 'Сторінка у твоїх кольорах', f3d: 'Кольори, шрифт, лого й фон — 16 готових тем або власна палітра. Нуль коду.',
    f4t: 'Розклад і команда', f4d: 'Години роботи, вихідні, ролі (власник, адміністратор, майстер) — весь салон в одній панелі.',
    f5t: 'Послуги, ціни й клієнти', f5d: 'Прайс, індивідуальна ціна візиту та база клієнтів — усе під рукою.',
    f6t: 'Панель із календарем', f6d: 'Денний вигляд і календар зі швидким додаванням записів — весь день перед очима.',
    how_eyebrow: 'Старт за один вечір', how_title: 'Три кроки до першого запису',
    s1t: 'Створи салон і послуги', s1d: 'Додай команду, послуги й ціни. Перші 3 місяці безкоштовно, без картки.',
    s2t: 'Налаштуй сторінку й піддомен', s2d: 'Обери тему, налаштуй кольори й лого — сторінка запису працює на власній адресі салону.',
    s3t: 'Приймай записи 24/7', s3d: 'Поділись лінком — клієнти бронюють самі, а ти бачиш усе в календарі.',
    price_eyebrow: 'Прості тарифи', price_title: 'Платиш лише за майстрів. Без комісії з візитів.',
    price_sub: 'Нові салони отримують перші 3 місяці безкоштовно. Далі платиш за кожного майстра, який приймає записи. Зручна оплата карткою онлайн.',
    mo: 'міс.', per_master: 'за майстра / міс.', plan_title: 'Одна проста ставка', trial_tag: '3 місяці безкоштовно', plan_cta: 'Почати безкоштовно',
    b1: 'Публічна сторінка й онлайн-запис', b2: 'Без ліміту майстрів і послуг', b3: 'SMS-підтвердження запису',
    p1: 'Власний піддомен і брендування сторінки', p2: 'Календар, клієнти, бухгалтерія', p3: 'Промокоди й нагадування клієнтам', p4: 'Рахуються лише ті, хто приймає записи — адміни без календаря безкоштовно',
    price_note: 'Приклад: соло-майстер — 69 zł/міс., салон із 4 майстрами — 276 zł/міс. Скасувати можна будь-коли — доступ діє до кінця оплаченого періоду.',
    brand_eyebrow: 'Твій бренд, не наш', brand_title: 'Кожен салон — окремий бренд за власною адресою.',
    brand_sub: 'Тема й лого під тебе — а лінк має професійний вигляд у рекламі та соцмережах.',
    bl1: 'Власний піддомен і тема', bl2: 'Сторінка PL, UA та EN', bl3: 'Готовий лінк для реклами й соцмереж',
    cta_title: 'Готовий перенести записи в онлайн?', cta_sub: 'Створи салон за кілька хвилин або напиши нам — покажемо демо й допоможемо стартувати.',
    cta_btn: 'Створити салон', cta_btn2: 'Написати нам',
    foot_tag: 'Платформа онлайн-запису для салонів.',
  },
  en: {
    nav_features: 'Features', nav_how: 'How it works', nav_pricing: 'Pricing', nav_cta: 'Try for free', nav_login: 'Log in',
    hero_eyebrow: 'The platform for salons & independent pros',
    hero_h1: 'Your salon runs online — <em>bookings 24/7</em>, while you work.',
    hero_sub: 'Clients book themselves, confirm their number with an SMS code, and you see everything in one calendar.',
    hero_cta1: 'Start free', hero_cta2: 'See how it works',
    hero_n1: '3 months free', hero_n2: 'no card', hero_n3: 'cancel anytime',
    dev_sub: 'Online booking', dev_time: 'Pick a time', dev_code: 'SMS code', dev_btn: 'Book', dev_booked: 'Booked — see you soon!',
    v1: 'Online bookings, no phone tag', v2: 'Number confirmed by code', v3: 'Commission on bookings', v4: 'Page in three languages',
    feat_eyebrow: 'Everything in one place', feat_title: 'You run the salon. appointMe handles the rest.',
    feat_sub: 'From the first booking to your own branded page — no code, no paperwork.',
    f1t: 'Online booking with a code', f1d: 'Clients pick a service, a pro and a time, and confirm their number by SMS code — no more no-shows.',
    f2t: 'Your own page & subdomain', f2d: 'Every salon gets a branded page at your-salon.aptme.app — ready to advertise.',
    f3t: 'A page in your colors', f3d: 'Colors, font, logo and background — 16 ready themes or your own palette. Zero code.',
    f4t: 'Schedule & team', f4d: 'Working hours, days off, roles (owner, admin, pro) — the whole salon in one panel.',
    f5t: 'Services, prices & clients', f5d: 'Price list, custom per-visit price and client base — all at hand.',
    f6t: 'Calendar dashboard', f6d: 'Day view and calendar with quick booking — your whole day at a glance.',
    how_eyebrow: 'Live in one afternoon', how_title: 'Three steps to your first booking',
    s1t: 'Create the salon & services', s1d: 'Add your team, services and prices. First 3 months free, no card required.',
    s2t: 'Set up page & subdomain', s2d: 'Choose a theme, set your colors and logo — your booking page runs on your own salon address.',
    s3t: 'Take bookings 24/7', s3d: 'Share the link — clients book themselves and you see it all in the calendar.',
    price_eyebrow: 'Simple pricing', price_title: 'Pay only per professional. No commission on visits.',
    price_sub: 'New salons get the first 3 months free. Then you pay per professional who takes bookings. Convenient online card payment.',
    mo: 'mo', per_master: 'per pro / mo', plan_title: 'One simple rate', trial_tag: '3 months free', plan_cta: 'Start free',
    b1: 'Public page and online booking', b2: 'Unlimited pros and services', b3: 'SMS confirmations',
    p1: 'Your own subdomain and page branding', p2: 'Calendar, clients, accounting', p3: 'Promo codes and client reminders', p4: 'Only pros who take bookings count — admins without a calendar are free',
    price_note: 'Example: a solo pro — 69 zł/mo, a salon with 4 pros — 276 zł/mo. Cancel anytime — access lasts until the end of the paid period.',
    brand_eyebrow: 'Your brand, not ours', brand_title: 'Every salon is its own brand at its own address.',
    brand_sub: 'Theme and logo tailored to you — and a link that looks professional in ads and on social.',
    bl1: 'Own subdomain & theme', bl2: 'Page in PL, UA & EN', bl3: 'A link ready for ads and social',
    cta_title: 'Ready to move your bookings online?', cta_sub: 'Set up your salon in minutes, or write to us — we’ll show a demo and help you launch.',
    cta_btn: 'Create salon', cta_btn2: 'Write to us',
    foot_tag: 'Online booking platform for salons.',
  },
};

const Check = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M20 6 9 17l-5-5" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default function Marketing() {
  const { i18n } = useTranslation();
  const lang = ['pl', 'uk', 'en'].includes(i18n.language) ? i18n.language : 'pl';
  const L = DICT[lang];
  const rootRef = useRef(null);

  // Скоуп мови для <html lang> лишаємо як є (керує глобальний i18n).
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Scroll-reveal + запобіжник
    const reveals = [...root.querySelectorAll('.reveal')];
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
    const fallback = setTimeout(() => reveals.forEach((el) => el.classList.add('in')), 2500);

    // Анімація віджета бронювання
    const chips = [...root.querySelectorAll('.mkt-chips .chip')];
    const otp = [...root.querySelectorAll('.mkt-otp i')];
    const booked = root.querySelector('.mkt-booked');
    const code = ['4', '2', '7', '1'];
    let alive = true;
    const wait = (ms) => new Promise((r) => setTimeout(r, ms));

    async function loop() {
      if (!chips.length) return;
      if (reduce) {
        chips[2].classList.add('is-active');
        otp.forEach((o, i) => { o.textContent = code[i]; o.classList.add('filled'); });
        booked && booked.classList.add('show');
        return;
      }
      while (alive) {
        chips.forEach((c) => c.classList.remove('is-active'));
        otp.forEach((o) => { o.textContent = ''; o.classList.remove('filled'); });
        booked && booked.classList.remove('show');
        await wait(1100); if (!alive) return;
        chips[2].classList.add('is-active');
        await wait(750); if (!alive) return;
        for (let i = 0; i < otp.length; i++) { otp[i].textContent = code[i]; otp[i].classList.add('filled'); await wait(260); if (!alive) return; }
        await wait(450); if (!alive) return;
        booked && booked.classList.add('show');
        await wait(2600);
      }
    }
    loop();
    return () => { alive = false; io.disconnect(); clearTimeout(fallback); };
  }, [lang]);

  const setLang = (l) => changeLanguage(l);

  return (
    <div className="mkt" ref={rootRef}>
      <style>{CSS}</style>

      <header className="mkt-nav">
        <div className="mkt-wrap mkt-nav-in">
          <a className="mkt-brand" href="#top">appoint<b>Me</b></a>
          <nav className="mkt-links">
            <a href="#features">{L.nav_features}</a>
            <a href="#how">{L.nav_how}</a>
            <a href="#pricing">{L.nav_pricing}</a>
          </nav>
          <div className="mkt-right">
            <div className="mkt-lang" role="group" aria-label="Language">
              {['pl', 'uk', 'en'].map((l) => (
                <button key={l} onClick={() => setLang(l)} aria-pressed={lang === l}>
                  {l === 'uk' ? 'UA' : l.toUpperCase()}
                </button>
              ))}
            </div>
            <Link className="mkt-btn mkt-ghost mkt-login" to="/login">{L.nav_login}</Link>
            <Link className="mkt-btn mkt-primary" to="/register-business">{L.nav_cta}</Link>
          </div>
        </div>
      </header>

      <main id="top">
        {/* HERO */}
        <section className="mkt-hero">
          <div className="mkt-wrap mkt-hero-grid">
            <div>
              <p className="mkt-eyebrow">{L.hero_eyebrow}</p>
              <h1 dangerouslySetInnerHTML={{ __html: L.hero_h1 }} />
              <p className="mkt-lede">{L.hero_sub}</p>
              <div className="mkt-hero-cta">
                <Link className="mkt-btn mkt-primary" to="/register-business">{L.hero_cta1}</Link>
                <a className="mkt-btn mkt-ghost" href="#how">{L.hero_cta2}</a>
              </div>
              <div className="mkt-note">
                <span><i className="mkt-dot" />{L.hero_n1}</span>
                <span><i className="mkt-dot" />{L.hero_n2}</span>
                <span><i className="mkt-dot" />{L.hero_n3}</span>
              </div>
            </div>

            <div className="mkt-device" aria-hidden="true">
              <div className="mkt-dev-head">
                <div className="mkt-dev-logo">L</div>
                <div className="mkt-dev-name">Clean Hands Club<small>{L.dev_sub}</small></div>
              </div>
              <div className="mkt-dev-label">{L.dev_time}</div>
              <div className="mkt-chips">
                {['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30'].map((t) => (
                  <div className="chip" key={t}>{t}</div>
                ))}
              </div>
              <div className="mkt-dev-label">{L.dev_code}</div>
              <div className="mkt-otp"><i /><i /><i /><i /></div>
              <button className="mkt-devbtn">{L.dev_btn}</button>
              <div className="mkt-booked"><Check />{L.dev_booked}</div>
            </div>
          </div>
        </section>

        {/* VALUE STRIP */}
        <div className="mkt-values">
          <div className="mkt-wrap"><div className="mkt-values-in">
            <div className="mkt-val"><b>24/7</b><span>{L.v1}</span></div>
            <div className="mkt-val"><b>SMS</b><span>{L.v2}</span></div>
            <div className="mkt-val"><b>0%</b><span>{L.v3}</span></div>
            <div className="mkt-val"><b>PL·UA·EN</b><span>{L.v4}</span></div>
          </div></div>
        </div>

        {/* FEATURES */}
        <section className="mkt-block" id="features">
          <div className="mkt-wrap">
            <div className="mkt-sec-head reveal">
              <p className="mkt-eyebrow">{L.feat_eyebrow}</p>
              <h2>{L.feat_title}</h2>
              <p>{L.feat_sub}</p>
            </div>
            <div className="mkt-features reveal">
              {[['01', L.f1t, L.f1d], ['02', L.f2t, L.f2d], ['03', L.f3t, L.f3d], ['04', L.f4t, L.f4d], ['05', L.f5t, L.f5d], ['06', L.f6t, L.f6d]].map(([ix, t, d]) => (
                <div className="mkt-feat" key={ix}><div className="ix">{ix}</div><h3>{t}</h3><p>{d}</p></div>
              ))}
            </div>
          </div>
        </section>

        {/* HOW */}
        <section className="mkt-block mkt-tight" id="how">
          <div className="mkt-wrap">
            <div className="mkt-sec-head reveal">
              <p className="mkt-eyebrow">{L.how_eyebrow}</p>
              <h2>{L.how_title}</h2>
            </div>
            <div className="mkt-steps reveal">
              {[['1', L.s1t, L.s1d], ['2', L.s2t, L.s2d], ['3', L.s3t, L.s3d]].map(([n, t, d]) => (
                <div className="mkt-step" key={n}><div className="n">{n}</div><h3>{t}</h3><p>{d}</p></div>
              ))}
            </div>
          </div>
        </section>

        {/* PRICING */}
        <section className="mkt-block mkt-tight" id="pricing">
          <div className="mkt-wrap">
            <div className="mkt-sec-head reveal">
              <p className="mkt-eyebrow">{L.price_eyebrow}</p>
              <h2>{L.price_title}</h2>
              <p>{L.price_sub}</p>
            </div>
            <div className="mkt-price mkt-price-single reveal">
              <div className="mkt-plan pro">
                <span className="tag">{L.trial_tag}</span>
                <h3>{L.plan_title}</h3>
                <div className="amt">69<small> PLN {L.per_master}</small></div>
                <ul>
                  <li><Check /><span>{L.b1}</span></li>
                  <li><Check /><span>{L.b2}</span></li>
                  <li><Check /><span>{L.b3}</span></li>
                  <li><Check /><span>{L.p1}</span></li>
                  <li><Check /><span>{L.p2}</span></li>
                  <li><Check /><span>{L.p3}</span></li>
                  <li><Check /><span>{L.p4}</span></li>
                </ul>
                <Link className="mkt-btn mkt-primary" to="/register-business">{L.plan_cta}</Link>
              </div>
            </div>
            <p className="mkt-price-note reveal">{L.price_note}</p>
          </div>
        </section>

        {/* BRAND BAND */}
        <section className="mkt-block mkt-tight">
          <div className="mkt-wrap">
            <div className="mkt-band reveal">
              <div className="mkt-band-grid">
                <div>
                  <p className="mkt-eyebrow mkt-gold">{L.brand_eyebrow}</p>
                  <h2>{L.brand_title}</h2>
                  <p>{L.brand_sub}</p>
                  <div className="mkt-band-list">
                    <div><Check /><span>{L.bl1}</span></div>
                    <div><Check /><span>{L.bl2}</span></div>
                    <div><Check /><span>{L.bl3}</span></div>
                  </div>
                </div>
                <div className="mkt-url"><b>clean-hands-club</b><span className="path">.aptme.app</span></div>
              </div>
            </div>
          </div>
        </section>

        {/* FINAL CTA */}
        <section className="mkt-block mkt-tight mkt-final" id="cta">
          <div className="mkt-wrap reveal">
            <h2>{L.cta_title}</h2>
            <p>{L.cta_sub}</p>
            <div className="mkt-final-cta">
              <Link className="mkt-btn mkt-primary" to="/register-business">{L.cta_btn}</Link>
              <a className="mkt-btn mkt-ghost" href="mailto:pmatsibokh@gmail.com?subject=appointMe">{L.cta_btn2}</a>
            </div>
          </div>
        </section>
      </main>

      <footer className="mkt-foot">
        <div className="mkt-wrap mkt-foot-in">
          <div>
            <div className="mkt-foot-brand">appoint<b>Me</b></div>
            <p>{L.foot_tag}</p>
          </div>
          <div className="mkt-foot-right">
            <a href="mailto:pmatsibokh@gmail.com">pmatsibokh@gmail.com</a>
            <span>© 2026 appointMe</span>
          </div>
        </div>
      </footer>
    </div>
  );
}

const CSS = `
.mkt {
  --ground:#F4EDE3; --raised:#FAF5EC; --ink:#2A1B16; --muted:#8A7263; --line:#E3D7C8;
  --accent:#6C1129; --accent-ink:#56081F; --plum:#241713; --gold:#A9713B; --ok:#6C1129;
  --serif:"Hoefler Text","Palatino Linotype",Palatino,"Iowan Old Style",Georgia,serif;
  --sans:ui-sans-serif,-apple-system,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif;
  --r:4px;
  background:var(--ground); color:var(--ink); font-family:var(--sans);
  font-size:17px; line-height:1.6; -webkit-font-smoothing:antialiased;
  min-height:100vh; overflow-x:hidden;
}
@media (prefers-color-scheme: dark){ .mkt{
  --ground:#1C1210; --raised:#261A15; --ink:#F2E9DF; --muted:#B7A293; --line:#3A2B23;
  --accent:#A34A62; --accent-ink:#C06B80; --plum:#140C09; --gold:#C79A63;
}}
.mkt *{box-sizing:border-box;}
.mkt .mkt-wrap{max-width:1120px; margin:0 auto; padding:0 24px;}
.mkt h1,.mkt h2,.mkt h3{font-family:var(--serif); font-weight:500; text-wrap:balance; margin:0; letter-spacing:-0.01em; color:var(--ink);}
.mkt h1{font-size:clamp(2.5rem,6vw,4.4rem); line-height:1.03;}
.mkt h2{font-size:clamp(1.9rem,3.6vw,2.9rem); line-height:1.08;}
.mkt h3{font-size:1.22rem; line-height:1.25;}
.mkt h1 em{font-style:italic; color:var(--accent-ink);}
.mkt p{margin:0;}
.mkt a{color:inherit; text-decoration:none;}
.mkt .mkt-eyebrow{font-family:var(--sans); font-size:0.72rem; font-weight:600; letter-spacing:0.18em; text-transform:uppercase; color:var(--accent-ink);}
.mkt .mkt-gold{color:var(--gold);}
.mkt .mkt-lede{color:var(--muted); font-size:1.12rem;}
.mkt .mkt-btn{display:inline-flex; align-items:center; gap:0.5em; cursor:pointer; font-family:var(--sans); font-size:0.98rem; font-weight:600; padding:0.82em 1.4em; border-radius:var(--r); border:1px solid transparent; transition:transform .15s, background .2s, border-color .2s, color .2s;}
.mkt .mkt-primary{background:var(--accent); color:#fff;}
.mkt .mkt-primary:hover{transform:translateY(-1px); background:var(--accent-ink);}
.mkt .mkt-ghost{background:transparent; color:var(--ink); border-color:var(--line);}
.mkt .mkt-ghost:hover{border-color:var(--accent); color:var(--accent-ink);}
.mkt .mkt-btn:focus-visible{outline:2px solid var(--accent); outline-offset:2px;}
.mkt .mkt-nav{position:sticky; top:0; z-index:40; backdrop-filter:saturate(1.2) blur(10px); background:color-mix(in srgb, var(--ground) 86%, transparent); border-bottom:1px solid var(--line);}
.mkt .mkt-nav-in{display:flex; align-items:center; gap:20px; height:66px;}
.mkt .mkt-brand{font-family:var(--serif); font-size:1.4rem; font-weight:600; letter-spacing:-0.02em;}
.mkt .mkt-brand b{color:var(--accent-ink); font-weight:600;}
.mkt .mkt-links{display:flex; gap:26px; margin-left:18px;}
.mkt .mkt-links a{font-size:0.92rem; color:var(--muted);}
.mkt .mkt-links a:hover{color:var(--ink);}
.mkt .mkt-right{margin-left:auto; display:flex; align-items:center; gap:12px;}
.mkt .mkt-lang{display:inline-flex; border:1px solid var(--line); border-radius:var(--r); overflow:hidden;}
.mkt .mkt-lang button{font-family:var(--sans); font-size:0.74rem; font-weight:600; letter-spacing:0.05em; padding:6px 9px; background:transparent; color:var(--muted); border:0; cursor:pointer;}
.mkt .mkt-lang button[aria-pressed="true"]{background:var(--accent); color:#fff;}
.mkt .mkt-hero{padding:clamp(48px,8vw,96px) 0 64px;}
.mkt .mkt-hero-grid{display:grid; grid-template-columns:1.05fr 0.95fr; gap:56px; align-items:center;}
.mkt .mkt-hero h1{margin:18px 0 0;}
.mkt .mkt-hero .mkt-lede{margin-top:22px; max-width:30em;}
.mkt .mkt-hero-cta{display:flex; flex-wrap:wrap; gap:14px; margin-top:30px;}
.mkt .mkt-note{margin-top:18px; font-size:0.86rem; color:var(--muted); display:flex; flex-wrap:wrap; gap:6px 16px;}
.mkt .mkt-note span{display:inline-flex; align-items:center; gap:6px;}
.mkt .mkt-dot{width:5px; height:5px; border-radius:50%; background:var(--gold); display:inline-block;}
.mkt .mkt-device{position:relative; background:var(--raised); border:1px solid var(--line); border-radius:14px; padding:22px; box-shadow:0 30px 60px -30px rgba(36,23,19,0.35);}
.mkt .mkt-dev-head{display:flex; align-items:center; gap:10px; padding-bottom:14px; border-bottom:1px solid var(--line);}
.mkt .mkt-dev-logo{width:34px; height:34px; border-radius:8px; background:linear-gradient(135deg,var(--accent),var(--plum)); display:grid; place-items:center; color:#fff; font-family:var(--serif); font-weight:600;}
.mkt .mkt-dev-name{font-weight:600; font-size:0.95rem;}
.mkt .mkt-dev-name small{display:block; color:var(--muted); font-weight:400; font-size:0.76rem;}
.mkt .mkt-dev-label{font-size:0.74rem; letter-spacing:0.1em; text-transform:uppercase; color:var(--muted); margin:16px 0 9px;}
.mkt .mkt-chips{display:grid; grid-template-columns:repeat(4,1fr); gap:8px;}
.mkt .mkt-chips .chip{font-family:var(--sans); font-variant-numeric:tabular-nums; font-size:0.9rem; padding:9px 0; text-align:center; border:1px solid var(--line); border-radius:var(--r); color:var(--ink); transition:background .25s,color .25s,border-color .25s;}
.mkt .mkt-chips .chip.is-active{background:var(--accent); border-color:var(--accent); color:#fff;}
.mkt .mkt-otp{display:flex; gap:8px;}
.mkt .mkt-otp i{flex:1; height:46px; border:1px solid var(--line); border-radius:var(--r); background:var(--ground); display:grid; place-items:center; font-style:normal; font-family:var(--serif); font-size:1.3rem; font-weight:600; color:var(--ink);}
.mkt .mkt-otp i.filled{border-color:var(--accent);}
.mkt .mkt-devbtn{width:100%; margin-top:16px; background:var(--accent); color:#fff; border:0; border-radius:var(--r); padding:12px; font-family:var(--sans); font-weight:600; font-size:0.95rem; cursor:pointer;}
.mkt .mkt-booked{display:flex; align-items:center; gap:10px; margin-top:14px; padding:13px 15px; border-radius:var(--r); background:color-mix(in srgb,var(--ok) 14%,transparent); color:var(--ok); font-weight:600; font-size:0.92rem; opacity:0; transform:translateY(6px); transition:opacity .4s, transform .4s;}
.mkt .mkt-booked.show{opacity:1; transform:none;}
.mkt .mkt-booked svg{flex:none;}
.mkt .mkt-values{border-top:1px solid var(--line); border-bottom:1px solid var(--line); background:var(--raised);}
.mkt .mkt-values-in{display:grid; grid-template-columns:repeat(4,1fr); gap:1px; background:var(--line);}
.mkt .mkt-val{background:var(--raised); padding:22px 24px;}
.mkt .mkt-val b{font-family:var(--serif); font-size:1.5rem; display:block; color:var(--ink);}
.mkt .mkt-val span{font-size:0.9rem; color:var(--muted);}
.mkt .mkt-block{padding:clamp(64px,9vw,104px) 0;}
.mkt .mkt-tight{padding-top:0;}
.mkt .mkt-sec-head{max-width:30em; margin-bottom:44px;}
.mkt .mkt-sec-head h2{margin-top:12px;}
.mkt .mkt-sec-head p{margin-top:16px; color:var(--muted); font-size:1.08rem;}
.mkt .mkt-features{display:grid; grid-template-columns:repeat(3,1fr); gap:1px; background:var(--line); border:1px solid var(--line); border-radius:8px; overflow:hidden;}
.mkt .mkt-feat{background:var(--ground); padding:30px 26px;}
.mkt .mkt-feat .ix{font-family:var(--serif); font-size:0.95rem; color:var(--accent-ink);}
.mkt .mkt-feat h3{margin:14px 0 8px;}
.mkt .mkt-feat p{color:var(--muted); font-size:0.96rem;}
.mkt .mkt-steps{display:grid; grid-template-columns:repeat(3,1fr); gap:30px;}
.mkt .mkt-step{border-top:2px solid var(--accent); padding-top:20px;}
.mkt .mkt-step .n{font-family:var(--serif); font-size:2.4rem; line-height:1; color:var(--ink);}
.mkt .mkt-step h3{margin:12px 0 8px;}
.mkt .mkt-step p{color:var(--muted); font-size:0.96rem;}
.mkt .mkt-price{display:grid; grid-template-columns:1fr 1fr; gap:24px; max-width:760px;}
.mkt .mkt-price-single{grid-template-columns:minmax(0,420px); justify-content:start;}
.mkt .mkt-plan{background:var(--raised); border:1px solid var(--line); border-radius:10px; padding:30px; display:flex; flex-direction:column;}
.mkt .mkt-plan.pro{border-color:var(--accent); box-shadow:0 20px 50px -34px rgba(108,17,41,0.45); position:relative;}
.mkt .mkt-plan .tag{position:absolute; top:-12px; right:22px; background:var(--accent); color:#fff; font-size:0.72rem; font-weight:700; letter-spacing:0.08em; text-transform:uppercase; padding:4px 10px; border-radius:20px;}
.mkt .mkt-plan h3{font-family:var(--sans); font-weight:700; font-size:1.05rem; letter-spacing:0.02em;}
.mkt .mkt-plan .amt{font-family:var(--serif); font-size:3rem; line-height:1; margin:14px 0 2px; color:var(--ink);}
.mkt .mkt-plan .amt small{font-family:var(--sans); font-size:0.95rem; font-weight:500; color:var(--muted);}
.mkt .mkt-plan ul{list-style:none; padding:0; margin:20px 0 26px; display:grid; gap:11px;}
.mkt .mkt-plan li{display:flex; gap:10px; font-size:0.96rem; align-items:flex-start;}
.mkt .mkt-plan li svg{flex:none; margin-top:3px; color:var(--accent);}
.mkt .mkt-plan .mkt-btn{margin-top:auto; justify-content:center;}
.mkt .mkt-price-note{margin-top:24px; font-size:0.9rem; color:var(--muted); max-width:760px;}
.mkt .mkt-band{background:var(--plum); border-radius:14px; padding:clamp(40px,6vw,68px); position:relative; overflow:hidden;}
.mkt .mkt-band::after{content:""; position:absolute; right:-80px; top:-80px; width:320px; height:320px; border-radius:50%; background:radial-gradient(circle,rgba(163,74,98,0.35),transparent 65%);}
.mkt .mkt-band-grid{display:grid; grid-template-columns:1.1fr 0.9fr; gap:44px; align-items:center; position:relative; z-index:1;}
.mkt .mkt-band h2{color:#fff;}
.mkt .mkt-band p{color:#CBB8A9; margin-top:16px; font-size:1.06rem;}
.mkt .mkt-url{font-family:var(--sans); background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.18); border-radius:var(--r); padding:14px 18px; font-size:1.05rem; color:rgba(255,255,255,0.55);}
.mkt .mkt-url b{color:#fff;}
.mkt .mkt-band-list{margin-top:22px; display:grid; gap:12px;}
.mkt .mkt-band-list div{display:flex; gap:10px; font-size:0.98rem; color:#E9DACB;}
.mkt .mkt-band-list svg{flex:none; margin-top:3px; color:var(--gold);}
.mkt .mkt-final{text-align:center;}
.mkt .mkt-final h2{margin:0 auto; max-width:16em;}
.mkt .mkt-final p{color:var(--muted); margin:16px auto 30px; max-width:30em;}
.mkt .mkt-final-cta{display:flex; gap:14px; justify-content:center; flex-wrap:wrap;}
.mkt .mkt-foot{border-top:1px solid var(--line); padding:40px 0 56px;}
.mkt .mkt-foot-in{display:flex; flex-wrap:wrap; gap:18px 40px; align-items:baseline;}
.mkt .mkt-foot-brand{font-family:var(--serif); font-size:1.2rem;}
.mkt .mkt-foot-brand b{color:var(--accent-ink);}
.mkt .mkt-foot p{color:var(--muted); font-size:0.85rem; margin-top:6px;}
.mkt .mkt-foot a{color:var(--muted); font-size:0.85rem;}
.mkt .mkt-foot-right{margin-left:auto; display:flex; gap:22px; font-size:0.85rem; color:var(--muted);}
.mkt .reveal{opacity:0; transform:translateY(16px); transition:opacity .7s ease, transform .7s ease;}
.mkt .reveal.in{opacity:1; transform:none;}
@media (max-width:860px){
  .mkt .mkt-hero-grid,.mkt .mkt-band-grid{grid-template-columns:1fr; gap:40px;}
  .mkt .mkt-values-in{grid-template-columns:1fr 1fr;}
  .mkt .mkt-features{grid-template-columns:1fr;}
  .mkt .mkt-steps{grid-template-columns:1fr; gap:26px;}
  .mkt .mkt-price{grid-template-columns:1fr;}
  .mkt .mkt-links,.mkt .mkt-login{display:none;}
}
@media (max-width:460px){ .mkt .mkt-values-in{grid-template-columns:1fr;} }
@media (prefers-reduced-motion: reduce){ .mkt .reveal{opacity:1; transform:none; transition:none;} }
`;
